import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NzMessageService} from 'ng-zorro-antd';

@Injectable()
export class DownloaderService {
    constructor(private http: HttpClient, private _message: NzMessageService) {

    }

    // filepath 文件完整地址，可以请求的文件
    // filename 下载后的文件名
    // postfix 下载后的文件后缀
    downloadFile(filepath: string, newfilename?: string) {
        if (!newfilename) {
            newfilename = this.getFileName(filepath);
        }

        return this.http.get(filepath, {responseType: 'blob'}).subscribe(results => {
            // Blob转化为链接
            const link = document.createElement('a');
            const blob = new Blob([results], {type: 'application/octet-stream'});
            const objectUrl = window.URL.createObjectURL(blob);
            link.setAttribute('href', objectUrl);
            link.setAttribute('download', newfilename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(objectUrl);
        }, error => {
            // 弹出全局提示条
            this._message.create('warning', `下载失败`);
        });
    }

    // 获取文件名带后缀
    getFileName(file) {
        const pos = file.lastIndexOf('/') * 1;
        return file.substring(pos + 1);
    }

    getFileSuffix(file) {
        return file.substring(file.lastIndexOf('.') + 1, file.length); // 后缀名
    }
}
